module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("By")]), _vm._v(" R"), _c('span', {
    staticClass: "t10"
  }, [_vm._v("EMMY")]), _vm._v(" D"), _c('span', {
    staticClass: "t10"
  }, [_vm._v("UCHENE")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Captive to His Wonder")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Deliver Me")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("With Allison Cassatta")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "t11"
  }), _c('span', {
    staticClass: "t9"
  }, [_vm._v("This is Love")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("With BLMorticia")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v(": Wounded Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Published b")]), _vm._v("y D"), _c('span', {
    staticClass: "t10"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t10"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("http://www.dreamspinnerpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("By")]), _vm._v(" BLM"), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ORTICIA")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("With Remmy Duchene")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v(": Wounded Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Published by")]), _vm._v(" D"), _c('span', {
    staticClass: "t10"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t10"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad4a8b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0